const PayMongoRedirect = () => {
  return <p>Redirecting...</p>;
};

export default PayMongoRedirect;
